/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPYESORNO } from './IAPYESORNO';
import {
    IAPYESORNOFromJSON,
    IAPYESORNOFromJSONTyped,
    IAPYESORNOToJSON,
} from './IAPYESORNO';
import type { PaymentDetailsDebitOrderBankAccountViewModel } from './PaymentDetailsDebitOrderBankAccountViewModel';
import {
    PaymentDetailsDebitOrderBankAccountViewModelFromJSON,
    PaymentDetailsDebitOrderBankAccountViewModelFromJSONTyped,
    PaymentDetailsDebitOrderBankAccountViewModelToJSON,
} from './PaymentDetailsDebitOrderBankAccountViewModel';

/**
 * 
 * @export
 * @interface PaymentDetailsDebitOrderViewModel
 */
export interface PaymentDetailsDebitOrderViewModel {
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsDebitOrderViewModel
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsDebitOrderViewModel
     */
    amount?: number;
    /**
     * 
     * @type {Date}
     * @memberof PaymentDetailsDebitOrderViewModel
     */
    debitOrderDate?: Date;
    /**
     * 
     * @type {IAPYESORNO}
     * @memberof PaymentDetailsDebitOrderViewModel
     */
    firstPaymentAsSoonAsPossible?: IAPYESORNO;
    /**
     * 
     * @type {Array<PaymentDetailsDebitOrderBankAccountViewModel>}
     * @memberof PaymentDetailsDebitOrderViewModel
     */
    clientDebitOrderBankAccounts: Array<PaymentDetailsDebitOrderBankAccountViewModel>;
    /**
     * 
     * @type {Array<PaymentDetailsDebitOrderBankAccountViewModel>}
     * @memberof PaymentDetailsDebitOrderViewModel
     */
    financialContributorsDebitOrderBankAccounts: Array<PaymentDetailsDebitOrderBankAccountViewModel>;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentDetailsDebitOrderViewModel
     */
    isFromPremiumInvestmentDate?: boolean;
}

/**
 * Check if a given object implements the PaymentDetailsDebitOrderViewModel interface.
 */
export function instanceOfPaymentDetailsDebitOrderViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "clientDebitOrderBankAccounts" in value;
    isInstance = isInstance && "financialContributorsDebitOrderBankAccounts" in value;

    return isInstance;
}

export function PaymentDetailsDebitOrderViewModelFromJSON(json: any): PaymentDetailsDebitOrderViewModel {
    return PaymentDetailsDebitOrderViewModelFromJSONTyped(json, false);
}

export function PaymentDetailsDebitOrderViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentDetailsDebitOrderViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'amount': !exists(json, 'Amount') ? undefined : json['Amount'],
        'debitOrderDate': !exists(json, 'DebitOrderDate') ? undefined : (new Date(json['DebitOrderDate'])),
        'firstPaymentAsSoonAsPossible': !exists(json, 'FirstPaymentAsSoonAsPossible') ? undefined : IAPYESORNOFromJSON(json['FirstPaymentAsSoonAsPossible']),
        'clientDebitOrderBankAccounts': ((json['ClientDebitOrderBankAccounts'] as Array<any>).map(PaymentDetailsDebitOrderBankAccountViewModelFromJSON)),
        'financialContributorsDebitOrderBankAccounts': ((json['FinancialContributorsDebitOrderBankAccounts'] as Array<any>).map(PaymentDetailsDebitOrderBankAccountViewModelFromJSON)),
        'isFromPremiumInvestmentDate': !exists(json, 'IsFromPremiumInvestmentDate') ? undefined : json['IsFromPremiumInvestmentDate'],
    };
}

export function PaymentDetailsDebitOrderViewModelToJSON(value?: PaymentDetailsDebitOrderViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'Amount': value.amount,
        'DebitOrderDate': value.debitOrderDate === undefined ? undefined : (value.debitOrderDate.toISOString().substr(0,10)),
        'FirstPaymentAsSoonAsPossible': IAPYESORNOToJSON(value.firstPaymentAsSoonAsPossible),
        'ClientDebitOrderBankAccounts': ((value.clientDebitOrderBankAccounts as Array<any>).map(PaymentDetailsDebitOrderBankAccountViewModelToJSON)),
        'FinancialContributorsDebitOrderBankAccounts': ((value.financialContributorsDebitOrderBankAccounts as Array<any>).map(PaymentDetailsDebitOrderBankAccountViewModelToJSON)),
        'IsFromPremiumInvestmentDate': value.isFromPremiumInvestmentDate,
    };
}

